import { useEffect } from 'react'
import Router from 'next/router'
import { ROUTE_CHANGE_ABORTED_ERROR_MESSAGE } from 'lib/consts/routeChange'
import { redirectIfTabUserSwitched } from 'lib/helpers/tabUser/tabUser'

/**
 * Covers the client navigations the Apollo link cannot see: a `getServerSideProps` page fetches its
 * data on the server, with the swapped cookie, and would render an access error for the old business.
 * Next emits `routeChangeStart` before that fetch, so throwing here cancels it.
 */
export const useRedirectOnTabUserSwitch = () => {
  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      if (redirectIfTabUserSwitched({ trigger: 'navigation', target: url })) {
        throw new Error(ROUTE_CHANGE_ABORTED_ERROR_MESSAGE)
      }
    }

    Router.events.on('routeChangeStart', handleRouteChangeStart)

    return () => Router.events.off('routeChangeStart', handleRouteChangeStart)
  }, [])
}
